import { Table } from './table';
import { Answer, FaqContent, Question, StyledList } from './styles';
import { FaqQuestionAndAnswer } from './types.d';

export const getFaqItem = (props: FaqQuestionAndAnswer) => {
  const {
    question,
    answer,
    answer2,
    list,
    centralizedAnswer,
    table,
    tableProps,
    translationComponents,
    TranslationWrapperComponent,
  } = props;

  return {
    header: {
      centralArea: <Question className="title-small">{question}</Question>,
    },
    content: (
      <FaqContent id="faq-content">
        {answer && (
          <Answer className="body-regular">
            <TranslationWrapperComponent
              i18nKey={answer}
              links={translationComponents}
            />
          </Answer>
        )}
        {table && <Table {...tableProps} />}
        {answer2 && (
          <Answer className="body-regular">
            <TranslationWrapperComponent
              i18nKey={answer2}
              links={translationComponents}
            />
          </Answer>
        )}
        {list && (
          <StyledList>
            {list?.map((item) => (
              <li key={item} className="body-large">
                <TranslationWrapperComponent i18nKey={item} />
              </li>
            ))}
          </StyledList>
        )}
        {centralizedAnswer && (
          <Answer
            className="body-regular"
            style={{ alignSelf: 'center', textAlign: 'center' }}
          >
            <TranslationWrapperComponent
              i18nKey={centralizedAnswer}
              links={translationComponents}
            />
          </Answer>
        )}
      </FaqContent>
    ),
    id: `question_${question}`,
  };
};
